import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import './HamburgerMenu.css'; // Import the CSS styles
import logo from '../../assests/images/login/logo-blue.svg';
import logoIconClosed from '../../assests/images/login/logo-icon-blue.svg';
import clients from '../../assests/images/Hamburger/clients.svg';
import accountants from '../../assests/images/Hamburger/accountants.svg';
import TrackingList from '../../assests/images/Hamburger/TrackingList.svg';
import TrackingListBlue from '../../assests/images/Hamburger/TrackingListBlue.svg';
import CalculateIcon from '@mui/icons-material/Calculate';
import reports from '../../assests/images/Hamburger/reports.svg';
import homeWhite from '../../assests/images/Hamburger/homeWhite.svg';
import profile from '../../assests/images/Hamburger/person.svg';
import logOut from '../../assests/images/Hamburger/logout.svg';
import salesIcon from '../../assests/images/Icons/sales1.svg';
import XtramCarLogo2 from '../../assests/images/XtramCarLogo2.png';
import bankIcon from '../../assests/images/Icons/bank.svg';
import xtramChatbotIcon from '../../assests/images/Icons/xtram-chatbot.png';
import cardMatchingIcon from '../../assests/images/Icons/cardMatching.svg';
import {
    AccountingModuleIcon,
    SalesModuleIcon,
    ArchiveModuleIcon,
    CrmModuleIcon,
    ReportsModuleIcon,
    SettingsModuleIcon,
    MatchingModuleIcon,
} from '../../assests/images/Icons/ModuleActionIcons';
import PuffLoader from "react-spinners/PuffLoader";
import bankPageIcon from '../../assests/images/Icons/collection.svg';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SummarizeIcon from '@mui/icons-material/Summarize';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ReportingFollowUpModal from '../ReportingFollowUp/ReportingFollowUpModal';
import ChatIcon from '@mui/icons-material/Chat';
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import useMediaQuery from '@mui/material/useMediaQuery';
import auditAiIcon from '../../assests/images/Icons/auditAi.svg';
import Tooltip from "@mui/material/Tooltip";
// Item Icons
import accountCardsDetailsIcon from '../../assests/images/Icons/accountCard.svg';
import incomesIcon from '../../assests/images/Icons/income.svg';
import expensesIcon from '../../assests/images/Icons/expense.svg';
import paymentAcceptanceIcon from '../../assests/images/Icons/paymentAcceptance.svg';
import journalEntryIcon from '../../assests/images/Icons/journalEntry.svg';
import otherDocumentIcon from '../../assests/images/Icons/otherDocument.svg';
import sortCodeReportIcon from '../../assests/images/Icons/sortcodeReport.svg';
import accountCardsTableIcon from '../../assests/images/Icons/ledger.svg';
import ledgerReportIcon from '../../assests/images/Icons/balance.svg';
import referenceSequenceIcon from '../../assests/images/Icons/referenceCheck.svg';
import generateDocIcon from '../../assests/images/Icons/generateDocument.svg';
import collectionsIcon from '../../assests/images/Icons/collection.svg';
import assignmentIcon from '../../assests/images/Icons/assignment.svg';
import InvoiceItemsIcon from '../../assests/images/Icons/documentItem.svg';
import advancesReportIcon from '../../assests/images/Icons/reports.svg';
import pcnFileIcon from '../../assests/images/Icons/reports.svg';
import vatReportIcon from '../../assests/images/Icons/reports.svg';
import transactionDocumentsIcon from '../../assests/images/Icons/financial.svg';
import profitAndLossIcon from '../../assests/images/Icons/profitAndLoss.svg';
import reportsIcon from '../../assests/images/Icons/reports1.svg';
import reports1Icon from '../../assests/images/Icons/reports.svg';
import assetIcon from '../../assests/images/Icons/assetIcon.svg';
import holdingItemsIcon from '../../assests/images/Icons/holdingItems.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthService from '../../Services/auth.service.js';
import UserService from '../../Services/user.service.js';
import { toast } from 'react-toastify';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import ClientService from '../../Services/client.service.js';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { formatDate_MM_YYYY } from '../../Utils/FormatDate.js';
import CustomMonthDatePicker from '../Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js';
import AutocompleteSelect from '../Widgets/AutocompleteSelect/AutocompleteSelect.jsx';
import CustomYearDatePicker from '../Widgets/CustomDates/CustomYearDatePicker/CustomYearDatePicker.js';
import ReportsService from '../../Services/reports.service.js';
import CircularProgress from '@mui/material/CircularProgress';
import ReferenceSequenceViewModal from '../ClientDetails/SubComponents/ModalsSection/ReferenceSequenceViewModal.jsx';
import ReferencesTreeModal from '../TransactionDocuments/SubComponents/ReferencesTreeModal.jsx';
import EnumsService from '../../Services/enums.service.js';
import { PermissionsContext } from '../../Contexts/Permissions.js';
// New imports for Radio Buttons
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Margin } from '@mui/icons-material';
import Chat from '../Chat/Chat.jsx';
import ManageLabelUsersModal from '../Chat/ManageLabelUsersModal/ManageLabelUsersModal.js';
import LabelService from '../../Services/labels.service.js';
import ChatApiService from '../../Services/chat.service.js';
import { playNotificationSound, showBrowserNotification } from '../../Utils/notificationUtils.js';
import { useChat } from '../../Contexts/ChatProvider.js';
import notificationSound from '../../assests/sounds/notification.mp3';
import useSound from 'use-sound';
import DownloadUniformFile from '../Widgets/DownloadUniformFile/DownloadUniformFile';
import TransactionSearchResultModal from '../Widgets/TransactionSearchResultModal/TransactionSearchResultModal';
import ChatBotModal from '../Widgets/ChatBotModal/ChatBotModal';
import Constants from '../../assests/Constants/constants.js';
import Download856Modal from '../Widgets/Download856Modal/Download856Modal.jsx';
import CustomModal from '../Widgets/CustomModal/CustomModal.jsx';
import { useClientNavigation } from '../../hooks/useClientNavigation.js';
import { splitOtherDocumentTypes } from '../../Utils/otherDocumentSections';
import { useMenuItems } from '../../hooks/useMenuItems.js'; // update path as needed
import businessFieldConfigs from '../../assests/Constants/businessFieldConfigs.js';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext.js';
import KeyboardShortcuts from '../KeyboardShortcuts/KeyboardShortcuts.jsx';
import ListAltIcon from '@mui/icons-material/ListAlt';
import Payment from '@mui/icons-material/Payment';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentStatusDialog from '../payments/PaymentStatusDialog.jsx';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useClientHeader } from '../ClientDetails/SubComponents/ClientDetailsHeader/ClientHeaderContext.js';
import PCNModal from '../PCN/PCNModal.jsx';
import PCNService from '../../Services/pcn.service.js';
import PCNChecksModal from '../PCN/PCNChecksModal.jsx';
import WithholdingModal from '../ClientDetails/SubComponents/ModalsSection/WithholdingModal.jsx';
import ClientWithholdingModal from '../ClientDetails/SubComponents/ModalsSection/ClientWithholdingModal.jsx';
import JournalDocumentationModal from '../Document/SubComponents/JournalDocumentationModal.jsx';
import ReportDateModal from '../Widgets/ReportDateModal/ReportDateModal.jsx';
import PartnerService from '../../Services/partner.service.js';

const MySwal = withReactContent(Swal);
const projectIcon = <FolderSpecialIcon sx={{ color: '#304FFF' }} />;

const formatDate = (date) => {
    return dayjs(date).toDate();
};



function HamburgerMenu({ client, payStat, payLoad, payErr, cancelPay }) {
    const { i18n, t } = useTranslation();
    const [searchBadgeOpen, setSearchBadgeOpen] = useState(false);
    const { permissions, permissionsState, loading: permissionsLoading, user, userTypeContext, token, isAccountant, resetPermissionsState, subAccountantCaseRestrictions } = useContext(PermissionsContext);
    const { subscribe, unsubscribe } = useChat();
    const [play] = useSound(notificationSound, { volume: 0.5 });
    const direction = i18n.dir();
    const navigate = useNavigate();
    const location = useLocation();
    // Highlights the nav row that owns the current route. Matches the route
    // itself plus anything nested under it, so deep links stay highlighted.
    const isNavActive = (path) => {
        const current = location.pathname.toLowerCase();
        const target = path.toLowerCase();
        return current === target || current.startsWith(`${target}/`);
    };
    const [isClientMenuOpen, setIsClientMenuOpen] = useState(false);
    const [expandedSections, setExpandedSections] = useState({});
    const [subMenuItem, setSubMenuItem] = useState(null);
    const [isDateModalOpen, setIsDateModalOpen] = useState(false);
    const [withHoldingTaxModalOpen, setWithHoldingTaxModalOpen] = useState(false);
    const [clientWithHoldingTaxModalOpen, setClientWithHoldingTaxModalOpen] = useState(false);
    const [withHoldingTaxType, setWithHoldingTaxType] = useState('');
    const [selectedReportType, setSelectedReportType] = useState('');
    const [showJournalDocModal, setShowJournalDocModal] = useState(false);
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [date, setDate] = useState(dayjs());
    const [isDateRange, setIsDateRange] = useState(false); // New state variable
    // Loading state is now managed by HamburgerMenuContext
    // const [token, setToken] = useState(null);
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const [selectedFormattedAccountCard, setSelectedFormattedAccountCard] = useState(null);
    const [selectedAccountCard, setSelectedAccountCard] = useState(null);
    const [selectedWithholdingCard, setSelectedWithholdingCard] = useState('');
    const [userId, setUserId] = useState('');
    const [userType, setUserType] = useState('');
    const [clientPaymentMethod, setClientPaymentMethod] = useState("");
    const [AccountCardOptions, setAccountCardOptions] = useState([]);
    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);

    //chatbot modal
    const [chatBotOpen, setChatBotOpen] = useState(false);
    const [chatBadgeOpen, setChatBadgeOpen] = useState(false);

    // const [isAccountant, setIsAccountant] = useState(false);
    const userIdRef = useRef(userId);
    const userTypeRef = useRef(userType);
    const [selectOtherDocumentsOptions, setSelectOtherDocumentsOptions] = useState([]);
    const hasSubscribedRef = useRef(false);
    // This is the label we want to manage (or it can be selected from somewhere)
    const [selectedLabel, setSelectedLabel] = useState(null);
    const [show856Modal, setShow856Modal] = useState(false);
    const [showUniformFileModal, setShowUniformFileModal] = useState(false);
    const [showReportDateModal, setShowReportDateModal] = useState(false);
    const [reportingFollowUpOpen, setReportingFollowUpOpen] = useState(false);
    const [partners, setPartners] = useState([]);
    // Allowed users for the label
    const [allowedUsers, setAllowedUsers] = useState([]);
    // State to control ManageLabelUsersModal
    const [showManageLabelModal, setShowManageLabelModal] = useState(false);
    const [unreadChat, setUnreadChat] = useState(0);
    const [searchModalOpen, setSearchModalOpen] = useState(false);
    const [parsedOtherDocuments, setParsedOtherDocuments] = useState([]);
    const [parsedPermanentFiles, setParsedPermanentFiles] = useState([]);
    const [parsedCustomTitles, setParsedCustomTitles] = useState([]);
    const [otherDocumentsTitles, setOtherDocumentsTitles] = useState([]);
    const [isPaymentErrorDismissed, setIsPaymentErrorDismissed] = useState(false);
    const [paymentErrorDismissedUntil, setPaymentErrorDismissedUntil] = useState(null);



    const { viewSubAccountants, viewUserActivity, viewTrackingList, viewAdvanceCalculator } = useClientNavigation(client);
    const {
        selectedDocumentId,
        selectedSectionKey,
        editModalDataSource,
        setEditModalDataSource,
        isJustEditModalOpen,
        isSearchModalOpen,
        handleDocumentRowClick,
        setSelectedDocumentId,
        setSelectedSectionKey,
        setIsJustEditModalOpen,
        setMenuProps,
        setAccountCardOptions: setContextAccountCardOptions,
        setSortCodeIdOptions: setContextSortCodeIdOptions,
        // PCN functions from HamburgerMenuContext
        showPCNModal,
        setShowPCNModal,
        showPCNChecksModal,
        setShowPCNChecksModal,
        pcnHighConfirmationDocs,
        setPcnHighConfirmationDocs,
        pcnDocumentsNeedingAllocation,
        setPcnDocumentsNeedingAllocation,
        pcnDocumentsWithoutReference,
        setPcnDocumentsWithoutReference,
        pcnDocumentsOutOfRange,
        setPcnDocumentsOutOfRange,
        pcnChecksLoading,
        setPcnChecksLoading,
        pcnReportDetails,
        setPcnReportDetails,
        loading,
        setLoading,
        pcnIncludeStornoChecks,
        setPcnIncludeStornoChecks,
        downloadPCNReport,
        handlePCNDownload,
        handlePCNChecks,
        refreshPCNData,
        // Chat functions from HamburgerMenuContext
        openChat,
        setOpenChat,
        chatKey,
        setChatKey,
        targetUserId,
        setTargetUserId,
        targetUserType,
        setTargetUserType,
        targetUserName,
        setTargetUserName,
        clarificationAttachContext,
        handleChatClose,
        // Enums refresh callback
        setRefreshEnumsCallback,
        referenceSequenceModalOpen,
        openReferenceSequenceModal,
        closeReferenceSequenceModal,
        referencesModalOpen,
        openReferencesModal,
        closeReferencesModal,
        menuProps,
        setOpenWithholdingTaxModel,

    } = useHamburgerMenu();


    // Handle document row click to send to hamburger menu
    const handleDocumentRowClickInDownloadImportModals = (doc) => {
        // Send document information to hamburger menu for processing
        if (doc && handleDocumentRowClick) {
            // Call the hamburger menu callback with document ID and document type
            handleDocumentRowClick(doc.id, doc.documentType);
        } else {
            console.warn('onDocumentRowClick is not available or doc is missing:', { doc, handleDocumentRowClickInDownloadImportModals });
        }
    };

    useEffect(() => {
        const shouldOpen =
            selectedDocumentId !== null && selectedSectionKey !== null;
        if (shouldOpen) {
            setSearchModalOpen(true);
        }
    }, [selectedDocumentId, selectedSectionKey]);
    const handlePressOpen = () => setCiOpen(true);
    const handlePressClose = () => setCiOpen(false);
    const [isOpen, setIsOpen] = useState(false);
    const isMobile = useMediaQuery('(max-width:1032px)');
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const effectiveOpen = isMobile ? isMobileOpen : isOpen;
    const [ciOpen, setCiOpen] = useState(false);
    const [showPaymentDlg, setShowPaymentDlg] = useState(false);
    const [cancelBusy, setCancelBusy] = useState(false);

    const refreshPaymentStatus = useCallback(() => {
        window.location.reload();
    }, []);

    const fetchChatInProgressRef = useRef(false);
    const fetchUnCountChat = useCallback(async (uId, uType) => {
        if (!uId || !uType) return;
        if (fetchChatInProgressRef.current) return;
        fetchChatInProgressRef.current = true;

        try {
            const unreadChats = await ChatApiService.getUnreadCountSummary(uId, uType);
            setUnreadChat(unreadChats);
        } catch (error) {
            console.error('Error fetching unread chats:', error);
        } finally {
            fetchChatInProgressRef.current = false;
        }
    }, []);

    useEffect(() => {
        userIdRef.current = userId;
        userTypeRef.current = userType;
    }, [userId, userType]);




    const openManageLabelUsersModal = (labelObj, users) => {
        // For example, store them in state
        setSelectedLabel(labelObj);
        setAllowedUsers(users || []);
        setShowManageLabelModal(true);
        setOpenChat(false)
        // Also, you could close the Chat if you want:
        // setOpenChat(false);
    };

    const [documentTypesCount, setDocumentTypesCount] = useState({});

    const setWithholdingTaxTypeFunc = (type) => {
        setWithHoldingTaxType(type);
        if (type === 'monthlyReport' || type === 'monthlyPeriodReport') {
            setIsDateRange(true);
        }
        else {
            setIsDateRange(false);
        }
    }

    const fetchEnumsInProgressRef = useRef(false);
    const fetchEnums = async (token, client, isSetLoading = false) => {
        try {
            if (!client) return;
            if (fetchEnumsInProgressRef.current) return;
            fetchEnumsInProgressRef.current = true;
            if (isSetLoading) setLoading(true);

            const response = await EnumsService.GetEnumPageData(client.caseId, client.accountantId, token);
            if (!response.ok) {
                throw new Error(`Server returned ${response.status}`);
            }
            const data = await response.json();

            setAccountCardOptions(data.accountCards ?? []);
            setSelectOtherDocumentsOptions(data.otherDocumentsTypes ?? []);
            setOtherDocumentsTitles(data.otherDocumentsTitles ?? []);
            setDocumentTypesCount(data.documentTypesCount ?? {});
            setSortCodeIdOptions(data.sortCodes ?? []);

            if (setContextAccountCardOptions) {
                setContextAccountCardOptions(data.accountCards ?? []);
            }
            if (setContextSortCodeIdOptions) {
                setContextSortCodeIdOptions(data.sortCodes ?? []);
            }

        } catch (error) {
            console.error('Error fetching enum data:', error);
            toast.error(t('fetchEnumsFailure', { errorText: error.message }));
        } finally {
            fetchEnumsInProgressRef.current = false;
            if (isSetLoading) setLoading(false);
        }
    };



    const formattedAccountCardOptions = AccountCardOptions?.map((option) => ({
        value: option.cardId,
        label: `${option.cardId} - ${option.name}`,
        cardId: option.cardId,
        name: option.name,
        companyId: option.accountCaseId,
        palCode: option.palCode,
    }));

    const referenceFormattedAccountCardOptions = formattedAccountCardOptions
        ? [...formattedAccountCardOptions]
        : [];
    if (referenceFormattedAccountCardOptions.length > 0) {
        referenceFormattedAccountCardOptions.shift();
    }

    const handleFormattedAccountCardChange = (event, newValue) => {
        setSelectedFormattedAccountCard(newValue);
    };

    const handleCloseReferenceSequenceModal = () => {
        closeReferenceSequenceModal();
        setSelectedFormattedAccountCard(null);
    };


    const formattedAccountSourceDeductionCardOptions = AccountCardOptions
        ?.filter((option) => option.sourceDeductionAssociation === 1) // Filter options
        .map((option) => ({
            value: option.cardId,
            label: `${option.cardId} - ${option.name}`,
            cardId: option.cardId,
            name: option.name,
            companyId: option.accountCaseId,
            palCode: option.palCode,
        }));

    useEffect(() => {
        // Check for saved language in localStorage
        const currentLanguage = localStorage.getItem('language') || 'he'; // Default to 'he' if no language is stored
        i18n.changeLanguage(currentLanguage);
    }, [i18n]);

    // useEffect(() => {
    //     const currentToken = UserService.getCurrentToken();
    //     if (currentToken) {
    //         setToken(currentToken);
    //     }
    // }, []);

    const clientCaseId = client?.caseId;
    const clientAccountantId = client?.accountantId;

    // Keep latest client/token in a ref so the callback always uses current values without re-registering
    const clientRef = useRef(client);
    const tokenRef = useRef(token);
    useEffect(() => { clientRef.current = client; }, [client]);
    useEffect(() => { tokenRef.current = token; }, [token]);

    useEffect(() => {
        if (client && token) {
            setClientPaymentMethod(client?.clientPaymentMethod?.toString())
            fetchEnums(token, client, false);
        }
    }, [clientCaseId, clientAccountantId, token]);

    // Register the refresh callback once — uses refs so no re-render cycle
    useEffect(() => {
        if (setRefreshEnumsCallback) {
            setRefreshEnumsCallback(() => {
                const c = clientRef.current;
                const t = tokenRef.current;
                if (c && t) {
                    fetchEnums(t, c, false);
                }
            });
        }
    }, [setRefreshEnumsCallback]);

    // Fetch partners when client is a partnership
    const fetchPartnersInProgressRef = useRef(false);
    useEffect(() => {
        const fetchPartners = async () => {
            if (!client?.isPartners || !token || !client?.caseId) {
                setPartners([]);
                return;
            }
            if (fetchPartnersInProgressRef.current) return;
            fetchPartnersInProgressRef.current = true;

            try {
                const response = await PartnerService.getPartnersByCaseId(client.caseId, token);
                if (response.ok) {
                    const partnersData = await response.json();
                    setPartners(partnersData);
                }
            } catch (error) {
                console.error('Error fetching partners:', error);
                setPartners([]);
            } finally {
                fetchPartnersInProgressRef.current = false;
            }
        };

        fetchPartners();
    }, [client, token]);

    const handleUserSend = useCallback(async (senderId, senderType) => {
        // Re-fetch unread counts

        await fetchUnCountChat(userIdRef.current, userTypeRef.current);

        // Play the sound
        play();

        if (!openChat) {
            showBrowserNotification(t('NewMessage'), t('YouHaveANewMessage'));
        }
    }, []);

    useEffect(() => {
        if (!hasSubscribedRef.current) {
            subscribe('UserSend', handleUserSend);
            hasSubscribedRef.current = true;
        }
        return () => {
            unsubscribe('UserSend', handleUserSend);
            hasSubscribedRef.current = false;
        };
    }, [subscribe, unsubscribe, handleUserSend]);

    useEffect(() => {

        if (userIdRef.current && userTypeRef.current) {
            fetchUnCountChat(userIdRef.current, userTypeRef.current);
        }
    }, [userIdRef.current, userTypeRef.current, openChat]);

    const handleMouseEnter = () => {
        if (!isMobile) setIsOpen(true);
    };
    const handleMouseLeave = () => {
        if (!isMobile) setIsOpen(false);
    };

    const handleMobileToggle = () => setIsMobileOpen((prev) => !prev);
    const handleMobileClose = () => setIsMobileOpen(false);

    useEffect(() => {
        if (!isMobile) setIsMobileOpen(false);
    }, [isMobile]);

    useEffect(() => {
        if (isMobile && isMobileOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMobile, isMobileOpen]);

    const handleLogout = async () => {
        try {
            console.log('🚪 Logging out - Clearing all session state');
            resetPermissionsState();
            await AuthService.logout();
            navigate('/login', { replace: true });
        } catch (error) {
            console.error('Error during logout:', error);
            navigate('/login', { replace: true });
        }
    };
    useEffect(() => {
        setMenuProps({
            client,
            token,
            isDateRange,
            date,
            startDate,
            endDate
        });
    }, [client, token, isDateRange, date, startDate, endDate, setMenuProps]);
    const checkLogoutInProgressRef = useRef(false);
    const checkLogoutTime = async () => {
        if (checkLogoutInProgressRef.current) return;
        checkLogoutInProgressRef.current = true;
        try {
            const Token = await UserService.getCurrentToken();
            const validTokenDate = await AuthService.CheckTokenValidation(Token);
            if (!validTokenDate.isValid) {
                toast.info(t('YouNeedToLogInAgain'));
                handleLogout();
            }

            const currentUserTypeVal = await AuthService.getCurrentUserType();
            const currentUserIdVal = await AuthService.getCurrentUserTypeId();
            setUserId(currentUserIdVal);
            setUserType(currentUserTypeVal);
        } catch (error) {
            toast.info(t('YouNeedToLogInAgain'));
            handleLogout();
        } finally {
            checkLogoutInProgressRef.current = false;
        }
    };

    useEffect(() => {
        checkLogoutTime();
    }, []);

    const handleGoClientDetails = () => {
        if (client) {
            navigate('/client-details', { state: { client }, replace: true });
        }
    };

    // Handle section expansion (for hover)
    const handleSectionHover = (sectionTitle) => {
        // For VehicleManagement, don't expand on hover
        if (sectionTitle === t('VehicleManagement')) {
            return;
        }

        setSubMenuItem(null)
        setExpandedSections((prev) => ({
            ...prev,
            [sectionTitle]: !prev[sectionTitle],
        }));
    };

    // Handle section click (for navigation)
    const handleSectionClick = (sectionTitle) => {
        setSubMenuItem(null)
        setExpandedSections((prev) => ({
            ...prev,
            [sectionTitle]: !prev[sectionTitle],
        }));
    };

    const openDateModal = (reportType) => {
        setSelectedReportType(reportType);
        // Use new ReportDateModal for WithholdingTax and VAT
        if (reportType === 'WithholdingTax' || reportType === 'VAT') {
            setShowReportDateModal(true);
        } else {
            // Use PCNModal for PCN reports
            setIsDateModalOpen(true);
        }
    };

    const openWithholdingTaxModel = useCallback((reportType) => {
        setSelectedReportType(reportType);
        setWithHoldingTaxModalOpen(true);
    }, []);

    useEffect(() => {
        setOpenWithholdingTaxModel?.(openWithholdingTaxModel);
        return () => setOpenWithholdingTaxModel?.(null);
    }, [openWithholdingTaxModel, setOpenWithholdingTaxModel]);

    const openClientWithholdingTaxModel = (reportType) => {
        setSelectedReportType(reportType);
        setClientWithHoldingTaxModalOpen(true);
    };

    const handleDownloadReceptionLog = () => {
        setShowJournalDocModal(true);
    };

    const onSubmitJournalDocumentation = async ({
        types,
        sortBy,
        sortDirection,
        format,
        startDate: modalStart,
        endDate: modalEnd,
        includeDescription = true,
        documentIds = null,
        dateType = 'registration',
        debitAccountIds = null,
        creditAccountIds = null,
        referenceFrom = null,
        referenceTo = null,
        sortCodeIds = null
    }) => {
        setLoading(true);
        try {
            const StartDate = modalStart ? modalStart : (isDateRange ? startDate : date);
            const EndDate = modalEnd ? modalEnd : (isDateRange ? endDate : date);
            const selectedTypes = (types && types.length > 0) ? types : [];
            const finalDocumentIds = documentIds || null;

            const filters = {
                dateType,
                ...(debitAccountIds && { debitAccountIds }),
                ...(creditAccountIds && { creditAccountIds }),
                ...(referenceFrom && { referenceFrom }),
                ...(referenceTo && { referenceTo }),
                ...(sortCodeIds && { sortCodeIds })
            };

            if (format === 'excel') {
                const blob = await ReportsService.getJournalEntryDocumentationExcel(
                    client.caseId,
                    StartDate,
                    EndDate,
                    selectedTypes,
                    token,
                    sortBy,
                    sortDirection,
                    includeDescription,
                    finalDocumentIds,
                    filters
                );
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `JournalDocumentation-${client.caseId}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                // PDF
                const blob = (selectedTypes.length > 1)
                    ? await ReportsService.getJournalEntryDocumentationCombinedPdf(
                        client.caseId,
                        StartDate,
                        EndDate,
                        selectedTypes,
                        token,
                        sortBy,
                        sortDirection,
                        includeDescription,
                        finalDocumentIds,
                        filters
                    )
                    : await ReportsService.getJournalEntryDocumentation(
                        client.caseId,
                        StartDate,
                        EndDate,
                        selectedTypes[0],
                        token,
                        sortBy,
                        sortDirection,
                        includeDescription,
                        finalDocumentIds,
                        filters
                    );

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `JournalDocumentation-${client.caseId}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }

            toast.success(t('reportDownloadSuccess'));
            setShowJournalDocModal(false);
        } catch (error) {
            console.error(error);
            toast.error(t('reportDownloadFailure'));
        } finally {
            setLoading(false);
        }
    };

    const closeDateModal = () => {
        setIsDateModalOpen(false);
        setShowReportDateModal(false);
        setSelectedReportType('');
        // Clear stored partnerId when closing
        sessionStorage.removeItem('selectedPartnerIdForReport');
    };

    const closeWithHoldingTaxModal = () => {
        setWithHoldingTaxModalOpen(false);
        setSelectedReportType('');
    };

    const closeClientWithHoldingTaxModal = () => {
        setClientWithHoldingTaxModalOpen(false);
        setSelectedReportType('');
    };

    const handleDownloadWithholdingReportReport = async (showZeroBalance = false, supplierNameFilter = '', useCreditAccount = false) => {
        if (withHoldingTaxType == '') {
            return
        }
        setLoading(true);
        // setWithHoldingTaxModalOpen(false);
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const formattedDate = formatDate(date);
        // Decide which dates to use based on isDateRange
        let start, end;
        if (isDateRange) {
            start = formattedStartDate;
            end = formattedEndDate;
        } else {
            start = formattedDate;
            end = formattedDate;
        }

        try {
            switch (withHoldingTaxType) {
                case 'yearlyCertificate':
                    await ReportsService.getSupplierWithholdingTaxCertificate(
                        client.caseId,
                        start,
                        client.accountantId,
                        selectedAccountCard?.value,
                        token,
                        false,
                        showZeroBalance,
                        useCreditAccount
                    );
                    break;

                case 'yearlyReport':
                    await ReportsService.getSupplierWithholdingTaxSummaryYearly(
                        client.caseId,
                        start,
                        client.accountantId,
                        token,
                        false,
                        showZeroBalance,
                        supplierNameFilter,
                        useCreditAccount
                    );
                    break;

                case 'monthlyReport':
                    await ReportsService.getSupplierWithholdingTaxSummary(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        false,
                        showZeroBalance,
                        supplierNameFilter,
                        useCreditAccount
                    );
                    break;

                case 'monthlyPeriodReport':
                    await ReportsService.getSupplierWithholdingTaxSummaryMonthlyPeriod(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        false,
                        showZeroBalance,
                        supplierNameFilter,
                        useCreditAccount
                    );
                    break;

                default:
                    console.warn('Invalid withholding tax type');
                    break;
            }
        } catch (error) {
            console.error(error);
            toast.error(t('reportDownloadFailure'));
        }
        setLoading(false);
    };

    const handleShowWithholdingReportReport = async (showZeroBalance = false, supplierNameFilter = '', useCreditAccount = false) => {
        if (withHoldingTaxType == '') {
            return '';
        }
        
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const formattedDate = formatDate(date);
        // Decide which dates to use based on isDateRange
        let start, end;
        if (isDateRange) {
            start = formattedStartDate;
            end = formattedEndDate;
        } else {
            start = formattedDate;
            end = formattedDate;
        }

        try {
            let html = '';
            switch (withHoldingTaxType) {
                case 'yearlyCertificate':
                    html = await ReportsService.getSupplierWithholdingTaxCertificate(
                        client.caseId,
                        start,
                        client.accountantId,
                        selectedAccountCard?.value,
                        token,
                        true,
                        showZeroBalance,
                        useCreditAccount
                    );
                    break;

                case 'yearlyReport':
                    html = await ReportsService.getSupplierWithholdingTaxSummaryYearly(
                        client.caseId,
                        start,
                        client.accountantId,
                        token,
                        true,
                        showZeroBalance,
                        supplierNameFilter,
                        useCreditAccount
                    );
                    break;

                case 'monthlyReport':
                    html = await ReportsService.getSupplierWithholdingTaxSummary(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        true,
                        showZeroBalance,
                        supplierNameFilter,
                        useCreditAccount
                    );
                    break;

                case 'monthlyPeriodReport':
                    html = await ReportsService.getSupplierWithholdingTaxSummaryMonthlyPeriod(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        true,
                        showZeroBalance,
                        supplierNameFilter,
                        useCreditAccount
                    );
                    break;

                default:
                    console.warn('Invalid withholding tax type');
                    break;
            }
            return html;
        } catch (error) {
            console.error(error);
            toast.error(t('reportShowFailure'));
            throw error;
        }
    };

    const handleDownloadClientWithholdingReportReport = async (showZeroBalance = true) => {
        if (withHoldingTaxType == '') {
            return
        }
        setLoading(true);
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const formattedDate = formatDate(date);
        // Decide which dates to use based on isDateRange
        let start, end;
        if (isDateRange) {
            start = formattedStartDate;
            end = formattedEndDate;
        } else {
            start = formattedDate;
            end = formattedDate;
        }

        try {
            switch (withHoldingTaxType) {
                case 'yearlyReport':
                    // Show SweetAlert modal to ask if user wants to include comparison columns
                    const result = await MySwal.fire({
                        title: t('IncludeComparisonInReport'),
                        text: t('IncludeComparisonInReport'),
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: t('Yes'),
                        cancelButtonText: t('No'),
                        customClass: { container: 'swal-high-zindex' },
                    });

                    // Determine showReportingColumns based on user's choice
                    const showReportingColumns = result.isConfirmed ? true : false;

                    await ReportsService.getClientWithholdingTaxSummaryYearly(
                        client.caseId,
                        start,
                        client.accountantId,
                        token,
                        false, // showMode = false (download PDF)
                        showZeroBalance,
                        showReportingColumns // showReportingColumns based on user's choice
                    );
                    break;

                case 'monthlyReport':
                    await ReportsService.getClientWithholdingTaxSummary(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        false,
                        showZeroBalance
                    );
                    break;

                case 'monthlyPeriodReport':
                    await ReportsService.getClientWithholdingTaxSummaryMonthlyPeriod(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        false,
                        showZeroBalance
                    );
                    break;

                default:
                    console.warn('Invalid client withholding tax type');
                    break;
            }
            toast.success(t('reportDownloadSuccess'));
        } catch (error) {
            console.error(error);
            toast.error(t('reportDownloadFailure'));
        }
        setLoading(false);
    };

    const handleDownloadClientWithholdingExcelReport = async (showZeroBalance = true) => {
        if (withHoldingTaxType == '') {
            return;
        }
        setLoading(true);
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const formattedDate = formatDate(date);
        // Decide which dates to use based on isDateRange
        let start, end;
        if (isDateRange) {
            start = formattedStartDate;
            end = formattedEndDate;
        } else {
            start = formattedDate;
            end = formattedDate;
        }

        try {
            let reportType;
            if (withHoldingTaxType === 'yearlyReport') {
                reportType = 'yearly';
            } else if (withHoldingTaxType === 'monthlyReport') {
                reportType = 'monthly';
            } else if (withHoldingTaxType === 'monthlyPeriodReport') {
                reportType = 'monthlyperiod';
            }

            await ReportsService.getClientWithholdingTaxSummaryExcel(
                client.caseId,
                start,
                end,
                client.accountantId,
                token,
                reportType,
                showZeroBalance
            );
            toast.success(t('reportDownloadSuccess'));
        } catch (error) {
            console.error('Error downloading client withholding Excel report:', error);
            toast.error(t('reportDownloadFailure'));
        }
        setLoading(false);
    };

    const handleShowClientWithholdingReportReport = async (showZeroBalance = false) => {
        if (withHoldingTaxType == '') {
            return '';
        }
        
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
        const formattedDate = formatDate(date);
        // Decide which dates to use based on isDateRange
        let start, end;
        if (isDateRange) {
            start = formattedStartDate;
            end = formattedEndDate;
        } else {
            start = formattedDate;
            end = formattedDate;
        }

        try {
            let html = '';
            switch (withHoldingTaxType) {


                case 'yearlyReport':
                    html = await ReportsService.getClientWithholdingTaxSummaryYearly(
                        client.caseId,
                        start,
                        client.accountantId,
                        token,
                        true, // showMode = true
                        showZeroBalance // showZeroBalance parameter

                    );
                    break;

                case 'monthlyReport':
                    html = await ReportsService.getClientWithholdingTaxSummary(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        true, // showMode = true
                        showZeroBalance // showZeroBalance parameter
                    );
                    break;

                case 'monthlyPeriodReport':
                    html = await ReportsService.getClientWithholdingTaxSummaryMonthlyPeriod(
                        client.caseId,
                        start,
                        end,
                        client.accountantId,
                        token,
                        true, // showMode = true
                        showZeroBalance // showZeroBalance parameter
                    );
                    break;

                default:
                    console.warn('Invalid client withholding tax type');
                    break;
            }
            return html;
        } catch (error) {
            console.error(error);
            toast.error(t('reportShowFailure'));
            throw error;
        }
    };

    const handleDownloadReport = async () => {
        setIsDateModalOpen(false);
        setLoading(true);
        try {
            const formattedStartDate = formatDate(startDate);
            const formattedEndDate = formatDate(endDate);
            const formattedDate = formatDate(date);

            // Decide which dates to use based on isDateRange
            let start, end;
            if (isDateRange) {
                start = formattedStartDate;
                end = formattedEndDate;
            } else {
                start = formattedDate;
                end = formattedDate;
            }   
            console.log(selectedReportType);
            
            switch (selectedReportType) {
                case 'ProfitAndLoss':
                    await ClientService.ProfitAndLossDetailsYearlyReport(
                        client.caseId,
                        client.accountantId,
                        start,
                        end,
                        token
                    );
                    break;
                case 'WithholdingTax': {
                    // Check sessionStorage for partnerId (set by partner selection dialog)
                    const storedPartnerId = sessionStorage.getItem('selectedPartnerIdForReport');
                    const partnerId = storedPartnerId || null;
                    if (storedPartnerId) {
                        sessionStorage.removeItem('selectedPartnerIdForReport');
                    }
                    // Honor the per-client "Only processed documents" toggle from ClientDetails.
                    // We don't have direct access to that state here (the hamburger menu lives
                    // outside the ClientDetails component tree), so we read the persisted value
                    // from localStorage — same key the ClientDetails toggle writes to.
                    // Default-on: treat a missing/unreadable value as TRUE so users that never
                    // opened ClientDetails still get processed-only reports.
                    const onlyProcessed = (() => {
                        try {
                            const stored = localStorage.getItem('ClientDetails.OnlyProcessed');
                            return stored === null ? true : stored === 'true';
                        } catch { return true; }
                    })();
                    await ReportsService.WithholdingTaxReport(
                        client.caseId,
                        client.accountantId,
                        start,
                        end,
                        token,
                        partnerId,
                        onlyProcessed
                    );
                    break;
                }
                case 'VAT': {
                    /* 1️⃣  Ask the server about missing docs                  */
                    const existRes = await ClientService.VatTransactionDocumentsExist(
                        {
                            caseId: client.caseId,
                            accountantId: client.accountantId,
                            startDate: start,
                            endDate: end,
                        },
                        token,
                    );

                    const netVatMissing = existRes?.data?.netVat === false;

                    /* 2️⃣  If something is missing, confirm with SweetAlert   */
                    if (netVatMissing) {
                        const result = await MySwal.fire({
                            title: t('UnprocessedDocumentsWarning'),
                            text: t('SomeTransactionsAreStillNotProcessed'),
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: t('Yes'),
                            cancelButtonText: t('No'),
                            customClass: { container: 'swal-high-zindex' },
                        });

                        if (!result.isConfirmed) {
                            setLoading(false);
                            return; // user aborted
                        }
                    }

                    /* 3️⃣  All clear — download the VAT report                */
                    // Honor the per-client "Only processed documents" toggle persisted by
                    // ClientDetails (same localStorage key). When true the backend will exclude
                    // unprocessed documents from the VAT aggregates / PDF output.
                    // Default-on: treat a missing/unreadable value as TRUE so users that never
                    // opened ClientDetails still get processed-only reports.
                    const onlyProcessed = (() => {
                        try {
                            const stored = localStorage.getItem('ClientDetails.OnlyProcessed');
                            return stored === null ? true : stored === 'true';
                        } catch { return true; }
                    })();
                    await ClientService.VATReport(
                        client.caseId,
                        client.accountantId,
                        start,
                        end,
                        token,
                        onlyProcessed,
                    );
                    break;
                }
                case 'PCN':
                    if (!client.isRequiredToReportPCN874) {
                        toast.warning(t("clientMustBeSetAsPCNReport")); // e.g., "Client must be set as PCN 874 reporter"
                        return;
                    }
                    await PCNService.DownloadPCNReport(
                        client.caseId,
                        start,
                        end,
                        token
                    );
                    // Delay between downloads if necessary
                    await delay(500);
                    await PCNService.DownloadPCNPDF(
                        client.caseId,
                        start,
                        end,
                    );
                    break;
                case 'PCN':
                    await PCNService.DownloadPCNReport(
                        client.caseId,
                        start,
                        end,
                    );
                    // Delay between downloads if necessary
                    await delay(500);
                    await PCNService.DownloadPCNPDF(
                        client.caseId,
                        start,
                        end,
                    );
                    break;
                default:
                    break;
            }
            toast.success(t('reportDownloadSuccess'));
        } catch (error) {
            console.error(error);
            toast.error(t('reportDownloadFailure'));
        }
        setLoading(false);
    };

    const handleSelectedAccountCardChangeForWithholding = (event, value) => {
        setSelectedWithholdingCard(value?.value || '');
        setSelectedAccountCard(value);
    };

    const onUsersUpdatedForLabel = async (labelId) => {
        try {
            // Fetch the list of labels
            const labelList = await LabelService.listLabels();
            // setLabels(labelList);

            // Find the label with the matching labelId
            const selectedLabel = labelList.find(label => label.labelId === labelId);

            // Set the selected label
            if (selectedLabel) {
                setSelectedLabel(selectedLabel);
            } else {
                console.warn(`Label with ID ${labelId} not found in labelList`);
                setSelectedLabel(null); // Clear selection if not found
            }
        } catch (error) {
            console.error("Error updating labels or setting selected label:", error);
        }
    };


    const {
        viewDocumentDetails,
        viewJournalEntryDetails,
        viewOtherDocumentDetails,
        viewClientItems,
        viewInventoryItems,
        viewPaymentAcceptanceDetails,
        viewProfitAndLossDetails,
        viewProfittAndLoss6111,
        viewReport1214,
        viewReport1214B,
        viewReport1281,
        viewReport1362,
        viewAnnualReportQuestionnaire,
        viewAnnualReport,
        viewTransactionDocuments,
        viewLedgerReport,
        viewAccountCardsTable,
        viewReceivables,
        viewReceivablesAging,
        viewCashFlowForecast,
        viewForeignTravelReport,
        viewClientExpenseAssignmentReport,
        viewBankTransactions,
        viewCollectionPage,
        viewAssignments,
        viewCardMatching,
        viewBankPage,
        viewAssets,
        viewProjects,
        viewDocumentCreate,
        viewAssignmentsByClient,
        viewHoldingItems,
        viewClarificationDocuments,
        viewVehicleManagement,
        viewGarageWorkDiary,
        viewAudit,
        viewAccountCardDashboardBAccountCard,
        viewAccountCardDashboard,
        viewAccountantDetails,
        viewSignatureDocument,
        viewForms,
        viewAddClient,
    } = useClientNavigation(client);

    // Modified handleItemClick function
    const handleItemClick = (itemOnClick, sectionTitle) => () => {

        if (itemOnClick) {
            itemOnClick();
        }
        setExpandedSections((prev) => ({
            ...prev,
            [sectionTitle]: false,
        }));
    };
    const {
        accountingItems,
        reportsItems,
        salesItems,
        vehicleItems,
        garageItems,
        auditItems,
        bankItems,
        documentsItems,
        settingsItems,
    } = useMenuItems({
        t,
        client,
        userTypeContext,
        permissionsState,
        Constants,
        parsedOtherDocuments,
        parsedPermanentFiles,
        parsedCustomTitles,
        viewAccountCardsTable,
        viewReceivables,
        viewReceivablesAging,
        viewCashFlowForecast,
        viewForeignTravelReport,
        viewClientExpenseAssignmentReport,
        viewDocumentDetails,
        viewPaymentAcceptanceDetails,
        viewJournalEntryDetails,
        viewAssets,
        viewProjects,
        viewProfitAndLossDetails,
        viewProfittAndLoss6111,
        viewReport1214,
        viewReport1214B,
        viewReport1281,
        viewReport1362,
        viewAnnualReportQuestionnaire,
        viewAnnualReport,
        viewLedgerReport,
        openReferenceSequenceModal,
        openReferencesModal,
        openWithholdingTaxModel,
        openClientWithholdingTaxModel,
        viewClientItems,
        viewInventoryItems,
        viewTransactionDocuments,
        viewDocumentCreate,
        viewBankTransactions,
        viewCardMatching,
        viewBankPage,
        viewOtherDocumentDetails,
        viewHoldingItems,
        viewClarificationDocuments,
        viewVehicleManagement,
        viewGarageWorkDiary,
        viewAudit,
        viewAccountCardDashboardBAccountCard,
        viewSignatureDocument,
        viewForms,
        viewAddClient,
        handleDownloadReceptionLog,
        // icons
        accountCardsDetailsIcon,
        incomesIcon,
        expensesIcon,
        paymentAcceptanceIcon,
        journalEntryIcon,
        projectIcon,
        holdingItemsIcon,
        assetIcon,
        auditIcon: auditAiIcon,
        sortCodeReportIcon,
        profitAndLossIcon,
        accountCardsTableIcon,
        referenceSequenceIcon,
        reportsIcon,
        reports1Icon,
        advancesReportIcon,
        pcnFileIcon,
        vatReportIcon,
        InvoiceItemsIcon,
        transactionDocumentsIcon,
        bankIcon,
        cardMatchingIcon,
        bankPageIcon,
        otherDocumentIcon,
        // hamburger-specific functions
        setShow856Modal,
        setShowUniformFileModal,
        openDateModal,
        // 🧭 Flag
        isFromHamburgerMenu: true,
        token,
        partners,
        subAccountantCaseRestrictions: subAccountantCaseRestrictions || []
    });

    useEffect(() => {
        // Show immediately on mount
        setChatBadgeOpen(true);
        const initialTimeout = setTimeout(() => setChatBadgeOpen(false), 5000);

        // Then repeat every 5 minutes
        const interval = setInterval(() => {
            setChatBadgeOpen(true);
            const hideTimeout = setTimeout(() => setChatBadgeOpen(false), 5000);
            return () => clearTimeout(hideTimeout);
        }, 300000); // 300,000 ms = 5 minutes

        return () => {
            clearTimeout(initialTimeout);
            clearInterval(interval);
        };
    }, []);

    const filteredSalesItems = salesItems.filter(item => {
        if (Constants.TaxExemptTypes.includes(client?.caseType)) {
            return item.label !== t('TaxInvoice') && item.label !== t('ReceiptTax') && item.label !== t('CreditNote') && item.label !== t('LawyerInvoice') && item.label !== t('LawyerReceipt');
        }
        return true;
    });



    useEffect(() => {
        if (client && selectOtherDocumentsOptions && selectOtherDocumentsOptions.length > 0) {
            const { otherDocuments, permanentFiles, customTitles } = splitOtherDocumentTypes(selectOtherDocumentsOptions, otherDocumentsTitles);

            const toSubItem = (doc, isPermanent, title = null) => ({
                label: doc.name,
                icon: otherDocumentIcon,
                number: documentTypesCount[doc.name] || 0,
                onClick: () => viewOtherDocumentDetails("OtherDocuments", doc.name, isPermanent, title),
            });

            setParsedOtherDocuments(otherDocuments.map((doc) => toSubItem(doc, false)));
            setParsedPermanentFiles(permanentFiles.map((doc) => toSubItem(doc, true)));
            setParsedCustomTitles(customTitles.map(({ title, types }) => ({
                label: title.name,
                onClick: () => viewOtherDocumentDetails("OtherDocuments", null, false, title),
                subItems: types.map((doc) => toSubItem(doc, false, title)),
            })));
        }

    }, [selectOtherDocumentsOptions, otherDocumentsTitles, documentTypesCount, client]);

    /* F1–F12 shortcuts are handled once in KeyboardShortcuts (capture phase) to avoid double navigation */

    const crmItems = [
        !permissionsState.ViewSubAccountantClients && {
            label: t('Collections'),
            icon: collectionsIcon,
            onClick: () => viewCollectionPage('CollectionPage'),
        },
        (!permissionsState.ViewSubAccountantClients && userTypeContext?.toString() !== Constants.UserType.Client) &&
        {
            label: t('Assignments'),
            icon: assignmentIcon,
            onClick: () => viewAssignmentsByClient('Assignments'),
            subItems: null

        },
        ...(isAccountant
            ? [{
                label: t('UserActivities'),
                icon: <ListAltIcon sx={{ color: '#3c51ff' }} />,
                onClick: () => viewUserActivity('UserActivities'),
                subItems: null,
            }]
            : []),
        {
            label: t('TrackingList'),
            icon: TrackingListBlue,
            onClick: () => viewTrackingList('TrackingList'),
            subItems: null

        },
        (!permissionsState.ViewSubAccountantClients && userTypeContext?.toString() !== Constants.UserType.Client) &&
        {
            label: t('ReportingFollowUp'),
            icon: <FactCheckIcon sx={{ color: '#3c51ff' }} />,
            onClick: () => setReportingFollowUpOpen(true),
            subItems: null,
        },
        {
            label: t('AdvanceDynamicCalculator'),
            icon: <CalculateIcon sx={{ color: '#3c51ff' }} />,
            onClick: () => viewAdvanceCalculator('AdvanceDynamicCalculator'),
            subItems: null,
        },
    ].filter(Boolean);

    const filteredReportsItems = reportsItems.filter(item => {
        const isClientWithoutPremium = userTypeContext?.toString() === Constants.UserType.Client && !permissionsState.Premium;
        if (isClientWithoutPremium) {
            return item.label !== t('ReportsForAuthority');
        }
        return true;
    });

    const clientMenuSections = [
        {
            title: t('Audit'),
            icon: auditAiIcon,
            items: auditItems,
            disabled: permissionsState.ViewSubAccountantClients || userTypeContext?.toString() === Constants.UserType.Client, // CRM should only be visible under specific conditions
            directClick: true,
            onDirectClick: () => viewAudit('Audit'),
            aiStyle: true,
            accent: 'orange',
        },
        {
            title: t('AccountingManagement'),
            iconComponent: <AccountingModuleIcon />,
            items: accountingItems,
            disabled: false, // Always enabled
            accent: 'blue',
        },
        {
            title: t('Settings'),
            iconComponent: <SettingsModuleIcon />,
            items: settingsItems,
            disabled: false,
            accent: 'purple',
        },
        {
            title: t('Reports'),
            iconComponent: <ReportsModuleIcon />,
            items: filteredReportsItems,
            disabled: false, // Always enabled
            accent: 'blue',
        },
        {
            title: t('Sales'),
            iconComponent: <SalesModuleIcon />,
            items: filteredSalesItems,
            disabled: false, // Always enabled
            accent: 'blue',
        },
        {
            title: t('CRM'),
            iconComponent: <CrmModuleIcon />,
            items: crmItems,
            disabled: permissionsState.ViewSubAccountantClients || userTypeContext?.toString() === Constants.UserType.Client, // CRM should only be visible under specific conditions
            accent: 'purple',
        },
        {
            title: t('Matching'),
            iconComponent: <MatchingModuleIcon />,
            items: bankItems,
            disabled: userTypeContext?.toString() === Constants.UserType.Client && !permissionsState.Premium, // Disabled for non-premium clients
            accent: 'orange',
        },
        {
            title: t('Archive'),
            iconComponent: <ArchiveModuleIcon />,
            items: documentsItems,
            disabled: false, // Always enabled
            accent: 'teal',
        },
    ];

    const filteredClientMenuSections = clientMenuSections.reduce((result, section) => {
        // Remove the 'CRM' section if the condition matches
        if (
            section.title === t('CRM') &&
            (permissionsState.ViewSubAccountantClients || userTypeContext?.toString() === Constants.UserType.Client)
        ) {
            return result;
        }

        // Hide AI Audit for client users
        if (
            section.title === t('Audit') &&
            userTypeContext?.toString() === Constants.UserType.Client
        ) {
            return result;
        }

        // Add section to the result with the existing or updated disabled property
        result.push({
            ...section,
            disabled: !!section.disabled, // Ensure disabled is a boolean
        });

        return result;
    }, []);

    // Modal styles
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 300,
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: 24,
        padding: 4,
    };

    const handleCancelWithConfirmation = async () => {
        const result = await MySwal.fire({
            title: t('AreYouSureCancel'),
            text: t('ThisWillCancelTrialOrSubscription'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('YesCancelIt'),
            cancelButtonText: t('KeepIt'),
            customClass: {
                container: 'swal-high-zindex'
            }
        });

        if (result.isConfirmed) {
            setCancelBusy(true);
            try {
                await cancelPay();
                window.location.reload();
            } catch (ex) {
                toast.error(ex.message || String(ex));
            } finally {
                setCancelBusy(false);
            }
        }
    };

    // Check if accountant has consecutive failures and next billing is less than 7 days
    const shouldShowPaymentError = () => {
        if (!payStat || userTypeContext?.toString() !== Constants.UserType.Accountant) return false;

        const hasConsecutiveFailures = payStat.consecutiveFailures > 0;
        const nextBillingDate = payStat.nextBillingOn ? new Date(payStat.nextBillingOn) : null;
        const daysUntilBilling = nextBillingDate ? Math.ceil((nextBillingDate - new Date()) / (1000 * 60 * 60 * 24)) : null;
        const isLessThan7Days = daysUntilBilling !== null && daysUntilBilling < 7;

        // Check if the banner is currently dismissed
        const now = new Date();
        const isCurrentlyDismissed = paymentErrorDismissedUntil && now < new Date(paymentErrorDismissedUntil);

        return hasConsecutiveFailures && isLessThan7Days && !isCurrentlyDismissed;
    };

    const handleDismissPaymentError = () => {
        // Set dismissal for 30 minutes from now
        const dismissUntil = new Date(Date.now() + 30 * 60 * 1000); // 30 minutes in milliseconds
        setPaymentErrorDismissedUntil(dismissUntil);
        setIsPaymentErrorDismissed(true);

        // Store the dismissal timestamp in localStorage
        localStorage.setItem('paymentErrorDismissedUntil', dismissUntil.toISOString());
    };

    // Restore dismissed state from localStorage on component mount
    useEffect(() => {
        const dismissedUntil = localStorage.getItem('paymentErrorDismissedUntil');
        if (dismissedUntil) {
            const dismissUntilDate = new Date(dismissedUntil);
            const now = new Date();

            // Check if the dismissal period has expired
            if (now < dismissUntilDate) {
                // Still within the dismissal period
                setPaymentErrorDismissedUntil(dismissUntilDate);
                setIsPaymentErrorDismissed(true);
            } else {
                // Dismissal period has expired, clear the localStorage
                localStorage.removeItem('paymentErrorDismissedUntil');
                setPaymentErrorDismissedUntil(null);
                setIsPaymentErrorDismissed(false);
            }
        }
    }, []);

    return (
        <>
            {/* Payment Error Alert */}
            {shouldShowPaymentError() && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: '#f44336',
                        color: 'white',
                        padding: '12px 16px',
                        textAlign: 'center',
                        zIndex: 9999,
                        fontSize: '14px',
                        fontWeight: 'bold',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        cursor: 'pointer'
                    }}
                    onClick={() => setShowPaymentDlg(true)}
                    title={t('ClickToUpdatePaymentMethod')}
                >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', position: 'relative' }}>
                        <span style={{ fontSize: '18px' }}>⚠️</span>
                        <span>{t('LastTransactionDeclined')}</span>
                        <span>•</span>
                        <span>{t('CreditCardRejected')}</span>
                        <span>•</span>
                        <span>{t('UpdateCardDetailsToPreventBlocking')}</span>
                        <span style={{ fontSize: '12px', opacity: 0.8 }}>({t('ClickToUpdate')})</span>
                        <div
                            style={{
                                position: 'absolute',
                                right: '16px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer',
                                padding: '4px',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(255,255,255,0.1)',
                                transition: 'background-color 0.2s'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDismissPaymentError();
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)';
                            }}
                            title={t('Close')}
                        >
                            <CloseIcon style={{ fontSize: '20px', color: 'white' }} />
                        </div>
                    </div>
                </div>
            )}

            {/* The layout mounts this component inside `.template-container`, which is a
                scroll container (overflow-y: auto) and is filtered while the payment dialog
                is open. Both make it the containing block for position: fixed descendants on
                some engines (and iPadOS Safari mis-anchors fixed elements inside scrollers
                outright), which dragged the sidebar downward with the container's scroll.
                Rendering the fixed chrome into <body> keeps the viewport as its containing
                block. */}
            {createPortal(
                <>
            {isMobile && isMobileOpen && (
                <button
                    type="button"
                    className="sidebar-backdrop"
                    onClick={handleMobileClose}
                    aria-label={t('Close')}
                />
            )}

            {isMobile && !isMobileOpen && (
                <div className="sidebar-mobile-bar">
                    <div className="sidebar-mobile-bar-inner">
                        <button
                            type="button"
                            className="sidebar-mobile-logo"
                            onClick={() => {
                                if (userTypeContext?.toString() === Constants.UserType.Client) {
                                    navigate('/client-details', { state: { client: user, replace: true } });
                                } else {
                                    navigate('/Main');
                                }
                            }}
                            aria-label="Xtram"
                        >
                            <img src={logo} alt="Xtram" />
                        </button>
                        <button
                            type="button"
                            className="sidebar-mobile-toggle"
                            onClick={handleMobileToggle}
                            aria-label={t('Menu')}
                        >
                            <MenuIcon />
                        </button>
                    </div>
                </div>
            )}

            <div
                className={`sidebar ${effectiveOpen ? 'open' : ''} ${isMobile ? (isMobileOpen ? 'mobile-open' : 'mobile-closed') : ''} ${direction}`}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                <button
                    type="button"
                    className={`sidebar-header-new ${direction}`}
                    onClick={() => {
                        if (userTypeContext?.toString() === Constants.UserType.Client) {
                            navigate('/client-details', { state: { client: user, replace: true } });
                        } else {
                            navigate('/Main');
                        }
                        if (isMobile) handleMobileClose();
                    }}
                >
                    <img src={effectiveOpen ? logo : logoIconClosed} alt="Logo" className={`sidebar-logo ${effectiveOpen ? 'is-open' : 'is-closed'}`} />
                </button>
                <div className={`sidebar-items ${isClientMenuOpen && effectiveOpen ? '' : 'is-scrollable'}`}>
                    {client && (
                        <>
                            <div
                                className={`sidebar-item ${direction} sidebar-item-main`}
                                style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                                onClick={() => setIsClientMenuOpen(!isClientMenuOpen)}
                            >
                                <div className="sidebar-item-content">
                                    <img src={salesIcon} alt="client" width={34} height={34} />
                                    <span>{client.name}</span>
                                </div>
                                {effectiveOpen && (
                                    <div className="sidebar-item-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                            className={isClientMenuOpen ? 'rotated' : ''}
                                        >
                                            <path
                                                d="M7.41 8.79492L12 13.3749L16.59 8.79492L18 10.2049L12 16.2049L6 10.2049L7.41 8.79492Z"
                                                fill="currentColor"
                                            />
                                        </svg>
                                    </div>
                                )}
                            </div>

                            {isClientMenuOpen && effectiveOpen && (
                                <>
                                    {/* First item: Client Page */}
                                    <div
                                        className={`submenu-item ${direction}`}
                                        onClick={() => {
                                            handleGoClientDetails();
                                            setIsClientMenuOpen(false); // Close client menu after click
                                        }}
                                    >
                                        <div className="sidebar-item-content">
                                            <img src={profile} alt="client page" width={24} height={24} />
                                            <span>{t('ClientPage')}</span>
                                        </div>
                                    </div>
                                    {
                                        (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium) &&
                                        <div
                                            className={`submenu-item ${direction}`}
                                            onClick={() => {
                                                setSearchModalOpen(true);
                                            }}
                                        >
                                            <div className="sidebar-item-content">
                                                <ManageSearchIcon
                                                    style={{ fontSize: 'var(--xtram-sidebar-icon, 24px)', marginInlineEnd: 4, color: 'white' }}
                                                />
                                                <span>{t('TransactionSearch')}</span>
                                            </div>
                                        </div>
                                    }

                                    {businessFieldConfigs.map((config, index) => {
                                        // Check if this business field matches the client's business field
                                        if (client?.businessField === config.businessFieldValue) {
                                            const accent = config.accent || 'blue';
                                            return (
                                                <div key={`business-field-${index}`} className="submenu-section">
                                                    <div
                                                        className={`submenu-item ${direction} submenu-item--accent-${accent}`}
                                                        onClick={() => {
                                                            // Handle direct click for business field buttons
                                                            if (config.directClick && config.navigationFunctionKey) {
                                                                // Call the appropriate navigation function
                                                                switch (config.navigationFunctionKey) {
                                                                    case 'viewVehicleManagement':
                                                                        viewVehicleManagement('VehicleManagement');
                                                                        break;
                                                                    case 'viewGarageWorkDiary':
                                                                        viewGarageWorkDiary('GarageWorkDiary');
                                                                        break;
                                                                    case 'viewAudit':
                                                                        viewAudit('Audit');
                                                                        break;
                                                                    default:
                                                                        console.warn(`Navigation function ${config.navigationFunctionKey} not implemented`);
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <div className="submenu-item-content">
                                                            {typeof config.icon === 'function' ? (
                                                                <span className="submenu-module-icon" aria-hidden="true">
                                                                    {React.createElement(config.icon)}
                                                                </span>
                                                            ) : (
                                                                <img src={config.icon} alt={t(config.titleKey)} width={24} height={24} />
                                                            )}
                                                            <span>{t(config.titleKey)}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }
                                        return null;
                                    })}

                                    {/* Render ClientActionCards for each section */}
                                    {filteredClientMenuSections.map((section, index) => (
                                        <div key={index} className={`submenu-section ${section.disabled ? 'disabled' : ''}`}>
                                            <div
                                                className={`submenu-item ${direction}${section.aiStyle ? ' submenu-item--ai' : ''}${
                                                    section.accent ? ` submenu-item--accent-${section.accent}` : ''
                                                }`}
                                                onMouseEnter={() => !section.disabled && !section.directClick && handleSectionClick(section.title)}
                                                onMouseLeave={() => !section.disabled && !section.directClick && handleSectionClick(section.title)}
                                                onClick={section.directClick && section.onDirectClick ? section.onDirectClick : undefined}
                                            >
                                                <div className="submenu-item-content">
                                                    {section.iconComponent ? (
                                                        <span className="submenu-module-icon" aria-hidden="true">
                                                            {section.iconComponent}
                                                        </span>
                                                    ) : (
                                                        <img src={section.icon} alt={section.title} width={24} height={24} />
                                                    )}
                                                    <span>{section.title}</span>
                                                </div>
                                                {/* Arrow SVG - Hide for direct-click sections */}
                                                {section.title !== t('VehicleManagement') && !section.directClick && (
                                                    <div className="submenu-item-arrow">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="25"
                                                            viewBox="0 0 24 25"
                                                            fill="none"
                                                            className={expandedSections[section.title] ? 'rotated' : ''}
                                                        >
                                                            <path
                                                                d="M7.41 8.79492L12 13.3749L16.59 8.79492L18 10.2049L12 16.2049L6 10.2049L7.41 8.79492Z"
                                                                fill="white"
                                                            />
                                                        </svg>
                                                    </div>
                                                )}
                                                {/* Flyout Submenu */}
                                                {(expandedSections[section.title] && !section.disabled) && (
                                                    <div className={`flyout-submenu ${direction}`}>
                                                        <div className={`flyout-submenu-main ${direction}`}>
                                                            {section.items.map((item, idx) => (
                                                                <div
                                                                    key={idx}
                                                                    className={`flyout-submenu-item ${direction}`}
                                                                    // onClick={
                                                                    //     item.onClick
                                                                    //         ? handleItemClick(item.onClick, section.title)
                                                                    //         : undefined
                                                                    // }
                                                                    onClick={() => {
                                                                        if (item.subItems) {
                                                                            setSubMenuItem((prevItem) => {
                                                                                // If prevItem is not empty and matches the current item, reset it
                                                                                if (prevItem) {
                                                                                    return null;
                                                                                }
                                                                                // Otherwise, set it as the current item
                                                                                return item;
                                                                            });
                                                                        } else if (item.onClick) {
                                                                            handleItemClick(item.onClick, section.title)();
                                                                            setExpandedSections({});
                                                                            setSubMenuItem(null);
                                                                        }
                                                                    }}
                                                                >
                                                                    <div className={`flyout-submenu-item-main ${direction}`}>

                                                                        <div className="flyout-submenu-item-content">
                                                                            {typeof item.icon === 'string' ? (
                                                                                <img src={item.icon} alt={item.label} width={24} height={24} />
                                                                            ) : (
                                                                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    {React.isValidElement(item.icon) 
                                                                                        ? item.icon 
                                                                                        : typeof item.icon === 'function' 
                                                                                            ? item.icon() 
                                                                                            : <item.icon />}
                                                                                </span>
                                                                            )}
                                                                            <span>{item.label}</span>
                                                                        </div>
                                                                        {item.count !== null && item.count !== undefined && (
                                                                            <div className="item-notification-count">{item.count}</div>
                                                                        )}
                                                                    </div>
                                                                    {item.subItems && (
                                                                        <div
                                                                            className="submenu-item-arrow"
                                                                            dir={direction} // dynamically set the direction
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="16"
                                                                                height="16"
                                                                                viewBox="0 0 24 24"
                                                                                fill="none"
                                                                                className="submenu-arrow-icon"
                                                                            >
                                                                                <path
                                                                                    d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z"
                                                                                    fill="#000"
                                                                                />
                                                                            </svg>
                                                                        </div>
                                                                    )}
                                                                    {/* SubSubItems */}
                                                                    {/* {item.subItems && (
                                                                    <div className={`flyout-subsubmenu ${direction}`}>
                                                                        {item.subItems.map((subItem, subIdx) => (
                                                                            <div
                                                                                key={subIdx}
                                                                                className={`flyout-subsubmenu-item ${direction}`}
                                                                                onClick={
                                                                                    subItem.onClick
                                                                                        ? handleItemClick(subItem.onClick, section.title)
                                                                                        : undefined
                                                                                }
                                                                            >
                                                                                <div className="flyout-subsubmenu-item-content">
                                                                                    <img
                                                                                        src={subItem.icon}
                                                                                        alt={subItem.label}
                                                                                        width={20}
                                                                                        height={20}
                                                                                    />
                                                                                    <span>{subItem.label}</span>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )} */}
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {

                                                            subMenuItem && subMenuItem.subItems &&
                                                            <div className={`flyout-subsubmenu ${direction}`}>
                                                                {subMenuItem.subItems.map((subItem, subIdx) => (
                                                                    <div
                                                                        key={subIdx}
                                                                        className={`flyout-subsubmenu-item ${direction}`}
                                                                        onClick={
                                                                            subItem.onClick
                                                                                ? handleItemClick(subItem.onClick, section.title)
                                                                                : undefined
                                                                        }
                                                                        onMouseLeave={() => setSubMenuItem({})}
                                                                        onMouseEnter={() => setSubMenuItem(subMenuItem)}
                                                                    >
                                                                        <div className="flyout-subsubmenu-item-content" style={{ justifyContent: 'space-between' }}>
                                                                            <div style={{ display: 'flex', gap: '5px' }}>
                                                                                {typeof subItem.icon === 'string' ? (
                                                                                    <img
                                                                                        src={subItem.icon}
                                                                                        alt={subItem.label}
                                                                                        width={20}
                                                                                        height={20}
                                                                                    />
                                                                                ) : (
                                                                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                                        {React.isValidElement(subItem.icon) 
                                                                                            ? subItem.icon 
                                                                                            : typeof subItem.icon === 'function' 
                                                                                                ? subItem.icon() 
                                                                                                : <subItem.icon />}
                                                                                    </span>
                                                                                )}
                                                                                <span>{subItem.label}</span>
                                                                            </div>


                                                                            {subItem.number !== null && subItem.number !== undefined && (
                                                                                <div className="item-notification-count">{subItem.number}</div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        }
                                                    </div>

                                                )}
                                            </div>
                                        </div>
                                    ))}

                                    {/* Render Business Field Buttons */}

                                </>
                            )}
                        </>
                    )}

                    {
                        userTypeContext?.toString() !== Constants.UserType.Client &&
                        <div
                            className={`sidebar-item ${direction} ${isNavActive('/Main') ? 'active' : ''}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={() => navigate('/Main')}
                        >
                            <div className="sidebar-item-content">
                                <img src={homeWhite} alt="home" width={24} height={24} />
                                <span>{t('clientDashboard')}</span>
                            </div>
                        </div>
                    }

                    {isAccountant && (
                        <div
                            className={`sidebar-item ${direction} ${isNavActive('/SubAccountants') ? 'active' : ''}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={viewSubAccountants}
                        >
                            <div className="sidebar-item-content">
                                <img src={accountants} alt="accountants" width={24} height={24} />
                                <span>{t('SubAccountantDashboard')}</span>
                            </div>
                        </div>
                    )}
                    {isAccountant && (
                        <div
                            className={`sidebar-item ${direction} ${isNavActive('/user-activities') ? 'active' : ''}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={() => viewUserActivity('UserActivities')}
                        >
                            <div className="sidebar-item-content">
                                <ListAltIcon sx={{ fontSize: 'var(--xtram-sidebar-icon, 24px)' }} />
                                <span>{t('UserActivities')}</span>
                            </div>
                        </div>
                    )}
                    {(!permissionsState.ViewSubAccountantClients && userTypeContext?.toString() !== Constants.UserType.Client) && (
                        <div
                            className={`sidebar-item ${direction} ${isNavActive('/TrackingList') ? 'active' : ''}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={() => viewTrackingList('TrackingList')}
                        >
                            <div className="sidebar-item-content">
                                <img src={TrackingList} alt="TrackingList" width={24} height={24} />
                                <span>{t('TrackingList')}</span>
                            </div>
                        </div>
                    )}
                    {!permissionsState.ViewSubAccountantClients && (
                        <div
                            className={`sidebar-item ${direction} ${isNavActive('/CreditTerminal') ? 'active' : ''}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={() => navigate('/CreditTerminal', {
                                state: {
                                    breadcrumbs: ['CreditTerminal'],
                                    previousLocation: {
                                        pathname: location.pathname,
                                        search: location.search || '',
                                        hash: location.hash || '',
                                        state: location.state || null,
                                    },
                                },
                            })}
                        >
                            <div className="sidebar-item-content">
                                <PointOfSaleIcon sx={{ fontSize: 'var(--xtram-sidebar-icon, 24px)', color: '#fff' }} />
                                <span>{t('CreditTerminal')}</span>
                            </div>
                        </div>
                    )}
                    {!permissionsState.ViewSubAccountantClients && (
                        <div
                            className={`sidebar-item ${direction} ${isNavActive('/Finsite') ? 'active' : ''}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={() => navigate('/Finsite', {
                                state: {
                                    breadcrumbs: ['Finsite'],
                                    previousLocation: {
                                        pathname: location.pathname,
                                        search: location.search || '',
                                        hash: location.hash || '',
                                        state: location.state || null,
                                    },
                                },
                            })}
                        >
                            <div className="sidebar-item-content">
                                <AccountBalanceIcon sx={{ fontSize: 'var(--xtram-sidebar-icon, 24px)', color: '#fff' }} />
                                <span>{t('Finsite')}</span>
                            </div>
                        </div>
                    )}
                    {/* {
                        !permissionsState.ViewSubAccountantClients &&
                        <div
                            className={`sidebar-item ${direction}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={() => navigate('/ReportTracking')}
                        >
                            <div className="sidebar-item-content">
                                <img src={reports} alt="reports" width={24} height={24} />
                                {effectiveOpen && <span>{t('ReportTracking')}</span>}
                            </div>
                        </div>
                    } */}
                    {
                        (!permissionsState.ViewSubAccountantClients && userTypeContext?.toString() !== Constants.UserType.Client) &&
                        <div
                            className={`sidebar-item ${direction} ${isNavActive('/Assignments') ? 'active' : ''}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={() => viewAssignments('Assignments')}
                        >
                            <div className="sidebar-item-content">
                                {/* <img src={reports} alt="reports" width={24} height={24} /> */}
                                <AssignmentIcon
                                    sx={{
                                        fontSize: 'var(--xtram-sidebar-icon, 24px)',
                                    }}
                                />
                                <span>{t('Assignments')}</span>
                            </div>
                        </div>
                    }
                    {
                        userTypeContext?.toString() !== Constants.UserType.Client &&
                        <div
                            className={`sidebar-item ${direction} ${isNavActive('/AnnualReport') ? 'active' : ''}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={() => navigate('/AnnualReport', {
                                state: {
                                    breadcrumbs: ['Reports', 'AnnualReport'],
                                    previousLocation: {
                                        pathname: location.pathname,
                                        search: location.search || '',
                                        hash: location.hash || '',
                                        state: location.state || null,
                                    },
                                },
                            })}
                        >
                            <div className="sidebar-item-content">
                                <SummarizeIcon sx={{ fontSize: 'var(--xtram-sidebar-icon, 24px)' }} />
                                <span>{t('annualReport.title')}</span>
                            </div>
                        </div>
                    }
                    {
                        !permissionsState.ViewSubAccountantClients &&
                        <div
                            className={`sidebar-item ${direction} ${openChat ? 'active' : ''}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={() => setOpenChat(true)}
                        >
                            <div className="sidebar-item-content">
                                {/* <img src={reports} alt="reports" width={24} height={24} /> */}
                                <svg
                                    width="21"
                                    height="21"
                                    viewBox="0 0 21 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M10.1666 20.5C15.6894 20.5 20.1666 16.0228 20.1666 10.5C20.1666 4.97715 15.6894 0.5 10.1666 0.5C4.64378 0.5 0.166626 4.97715 0.166626 10.5C0.166626 12.0997 0.542246 13.6116 1.21009 14.9525C1.38757 15.3088 1.44664 15.7161 1.34375 16.1006L0.748136 18.3267C0.489576 19.293 1.37364 20.177 2.33998 19.9185L4.56602 19.3229C4.95056 19.22 5.35784 19.2791 5.71416 19.4565C7.055 20.1244 8.56693 20.5 10.1666 20.5Z"
                                        fill={'white'}

                                    />
                                    <circle cx="7" cy="10" r="1" fill="black" />
                                    <circle cx="10.5" cy="10" r="1" fill="black" />
                                    <circle cx="14" cy="10" r="1" fill="black" />
                                </svg>
                                <span>{t('Chat')}</span>
                                {unreadChat > 0 && (
                                    <div className="unread-bubble2">
                                        {unreadChat}
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                    {
                        (!permissionsState.ViewSubAccountantClients && userTypeContext?.toString() !== Constants.UserType.Client) &&
                        <div
                            className={`sidebar-item ${direction} ${isNavActive('/Accountant-details') ? 'active' : ''}`}
                            style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                            onClick={() => navigate('/Accountant-details')}
                        >
                            <div className="sidebar-item-content">
                                <img src={profile} alt="profile" width={34} height={34} />
                                <span>{t('profile')}</span>
                            </div>
                        </div>
                    }

                </div>
                {((userType?.toString() === Constants.UserType.Client && clientPaymentMethod === Constants.ClientPaymentMethod.Client) || userTypeContext?.toString() === Constants.UserType.Accountant) && (
                    <div
                        className={`sidebar-item ${direction} ${showPaymentDlg ? 'active' : ''}`}
                        style={!effectiveOpen ? { justifyContent: 'center' } : {}}
                        onClick={() => setShowPaymentDlg(true)}
                    >
                        <div className="sidebar-item-content">
                            <Payment sx={{ fontSize: 'var(--xtram-sidebar-icon, 24px)' }} />
                            <span>{t('Subscription')}</span>
                        </div>
                    </div>
                )}
                <div className={`logout-item sidebar-item ${direction}`} onClick={handleLogout}>
                    <div className="sidebar-item-content">
                        <img src={logOut} alt="logout" width={24} height={24} />
                        <span>{t('logOut')}</span>
                    </div>
                </div>

            </div>
                </>,
                document.body
            )}
            {client && (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium) &&
                <div className={`floating-search-badge ${direction == 'ltr' ? 'rtl' : 'ltr'} ${searchBadgeOpen ? 'expanded' : 'collapsed'}`}>
                    <div
                        className="totals-header"
                        onClick={() => {
                            setSearchModalOpen(true);
                            setSearchBadgeOpen(false); // optional auto-collapse
                        }}
                        onMouseEnter={() => setSearchBadgeOpen(true)}
                        onMouseLeave={() => setSearchBadgeOpen(false)}
                    >
                        <ManageSearchIcon
                            style={{
                                fontSize: 'var(--xtram-sidebar-icon, 24px)',
                                verticalAlign: 'middle',
                                marginInlineEnd: searchBadgeOpen ? 8 : 0,
                                transition: 'margin 0.3s ease'
                            }}
                        />
                        {searchBadgeOpen && <span>{t('TransactionSearch')}</span>}
                    </div>
                </div>
            }




            {/* {(userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium) && (
                <Tooltip
                    title={<span style={{ fontSize: '14px' }}>💬 {t("XtramBotIntro")}</span>}
                    placement="right"
                    arrow
                    open={chatBadgeOpen}
                    onOpen={() => setChatBadgeOpen(true)}
                    onClose={() => setChatBadgeOpen(false)}
                >
                    <div
                        className="chatbot-float-button"
                        onClick={() => {
                            setChatBotOpen(true);
                            setChatBadgeOpen(false);
                        }}
                        onMouseEnter={() => setChatBadgeOpen(true)}
                        onMouseLeave={() => setChatBadgeOpen(false)}
                        aria-label="Chat with us"
                    >
                        <img
                            src={xtramChatbotIcon}
                            alt="Chat Icon"
                            className="chatbot-icon"
                        />
                    </div>
                </Tooltip>
            )} */}

            <Download856Modal
                open={show856Modal}
                onClose={() => setShow856Modal(false)}
                client={client}
                token={token}
            />

            <DownloadUniformFile
                open={showUniformFileModal}
                onClose={() => setShowUniformFileModal(false)}
                client={client}
                token={token}
            />


            {/* Report Date Modal for VAT and Advance Reports */}
            <ReportDateModal
                open={showReportDateModal}
                onClose={closeDateModal}
                direction={direction}
                isDateRange={isDateRange}
                setIsDateRange={setIsDateRange}
                date={date}
                setDate={setDate}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                onDownload={handleDownloadReport}
                reportType={selectedReportType}
                t={t}
            />

            {/* PCN Date Selection Modal */}
            <PCNModal
                open={isDateModalOpen}
                onClose={closeDateModal}
                direction={direction}
                isDateRange={isDateRange}
                setIsDateRange={setIsDateRange}
                date={date}
                setDate={setDate}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                CustomMonthDatePicker={CustomMonthDatePicker}
                // PCN Modal props from HamburgerMenuContext
                pcnIncludeStornoChecks={pcnIncludeStornoChecks}
                setPcnIncludeStornoChecks={setPcnIncludeStornoChecks}
                pcnChecksLoading={pcnChecksLoading}
                handlePCNChecks={handlePCNChecks}
                handlePCNDownload={handlePCNDownload}
                t={t}
                caseId={client?.caseId}
                token={token}
                viewDocumentDetails={(type) => {
                    // Navigate to the appropriate page based on type
                    if (type === 'Incomes') {
                        navigate(`/client-details/${client?.caseId}/incomes`);
                    }
                }}
            />

            {/* Withholding Tax Modal */}
            <WithholdingModal
                open={withHoldingTaxModalOpen}
                onClose={closeWithHoldingTaxModal}
                t={t}
                direction={direction}
                withHoldingTaxType={withHoldingTaxType}
                setWithholdingTaxTypeFunc={setWithholdingTaxTypeFunc}
                isDateRange={isDateRange}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                date={date}
                setDate={setDate}
                dayjs={dayjs}
                formattedAccountSourceDeductionCardOptions={formattedAccountSourceDeductionCardOptions}
                selectedAccountCard={selectedAccountCard}
                handleSelectedAccountCardChangeForWithholding={handleSelectedAccountCardChangeForWithholding}
                handleDownloadWithholdingReportReport={handleDownloadWithholdingReportReport}
                handleShowWithholdingReportReport={handleShowWithholdingReportReport}
                client={client}
                partners={[]}
                token={token}
            />

            {/* Client Withholding Tax Modal */}
            <ClientWithholdingModal
                open={clientWithHoldingTaxModalOpen}
                onClose={closeClientWithHoldingTaxModal}
                t={t}
                direction={direction}
                withHoldingTaxType={withHoldingTaxType}
                setWithholdingTaxTypeFunc={setWithholdingTaxTypeFunc}
                isDateRange={isDateRange}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                date={date}
                setDate={setDate}
                dayjs={dayjs}
                formattedAccountSourceDeductionCardOptions={formattedAccountSourceDeductionCardOptions}
                selectedAccountCard={selectedAccountCard}
                handleSelectedAccountCardChangeForWithholding={handleSelectedAccountCardChangeForWithholding}
                handleDownloadClientWithholdingReportReport={handleDownloadClientWithholdingReportReport}
                handleDownloadClientWithholdingExcelReport={handleDownloadClientWithholdingExcelReport}
                handleShowClientWithholdingReportReport={handleShowClientWithholdingReportReport}
                client={client}
                partners={[]}
            />

            {/* Journal Documentation Modal */}
            <JournalDocumentationModal
                open={showJournalDocModal}
                onClose={() => setShowJournalDocModal(false)}
                onSubmit={onSubmitJournalDocumentation}
                initialSortBy={'uploadNumber'}
                initialSortDirection={'asc'}
                initialTypes={[]}
                initialFormat={'pdf'}
                initialStartDate={isDateRange ? startDate : date}
                initialEndDate={isDateRange ? endDate : date}
                initialIsRange={isDateRange}
                accountCardOptions={AccountCardOptions.filter(opt => opt.cardId)}
                sortCodeOptions={sortCodeIdOptions}
                direction={direction}
            />

            {/* Reference Sequence View Modal */}
            <ReferenceSequenceViewModal
                open={referenceSequenceModalOpen}
                onClose={handleCloseReferenceSequenceModal}
                direction={direction}
                t={t}
                dayjs={dayjs}
                formattedAccountCardOptions={referenceFormattedAccountCardOptions}
                accountCardOptions={AccountCardOptions}
                selectedFormattedAccountCard={selectedFormattedAccountCard}
                handleFormattedAccountCardChange={handleFormattedAccountCardChange}
                AutocompleteSelect={AutocompleteSelect}
                client={client}
                token={token}
                user={user}
            />

            <ReportingFollowUpModal
                open={reportingFollowUpOpen}
                onClose={() => setReportingFollowUpOpen(false)}
                client={client}
                user={user}
                token={token}
                defaultDate={localStorage.getItem('Date') ? new Date(localStorage.getItem('Date')) : new Date()}
            />

            <ReferencesTreeModal
                open={referencesModalOpen}
                caseId={client?.caseId}
                token={token}
                onClose={closeReferencesModal}
                onSave={menuProps?.onReferencesSave}
            />

            {loading && (
                <div className="loader-container">
                    <PuffLoader
                        size={100}
                        loading={loading}
                    />
                </div>
            )}
            {
                !permissionsState.ViewSubAccountantClients &&
                <Chat
                    key={chatKey} // Pass the dynamic key to force remount
                    isOpen={openChat}
                    onClose={handleChatClose}
                    setOpenChat={setOpenChat}
                    onOpenManageLabelModal={openManageLabelUsersModal}
                    targetUserId={targetUserId}
                    targetUserType={targetUserType}
                    targetUserName={targetUserName}
                    clarificationAttachContext={clarificationAttachContext}
                />
            }
            <ManageLabelUsersModal
                visible={showManageLabelModal}
                onClose={() => setShowManageLabelModal(false)}
                onReopen={() => {
                    // Re-fetch data or re-open after saving changes
                    setShowManageLabelModal(true);
                }}
                label={selectedLabel}       // object with { labelId, labelName, users: [...] }
                userId={userId}
                onUsersUpdated={onUsersUpdatedForLabel}
                userType={userType}
                allowedUsers={allowedUsers} // array of all users that can be added
                setLoading={setLoading}
                loading={loading}
            />

            <ChatBotModal
                open={chatBotOpen}
                onClose={() => setChatBotOpen(false)}
                accountantId={user?.accountantId}
                token={token}
                t={t}
            />

            <TransactionSearchResultModal
                open={searchModalOpen}
                onClose={() => setSearchModalOpen(false)}
                caseId={client?.caseId}
                accountantId={client?.accountantId}
                client={client}
                user={user}
                token={token}
                formattedAccountCardOptions={formattedAccountCardOptions}
                accountsData={AccountCardOptions}
                sortCodes={sortCodeIdOptions}
                onRowClick={(row, section) => {
                    console.log("clicked", section, row);
                    // navigate to detail page or open another modal
                }}
                // New props for direct edit modal
                openJustEditModal={isJustEditModalOpen}
                selectedDocumentId={selectedDocumentId}
                selectedSectionKey={selectedSectionKey}
                editModalDataSource={editModalDataSource}
                setEditModalDataSource={setEditModalDataSource}
                setSelectedDocumentId={setSelectedDocumentId}
                setSelectedSectionKey={setSelectedSectionKey}
                setIsJustEditModalOpen={setIsJustEditModalOpen}
            />

            <PaymentStatusDialog
                open={showPaymentDlg}
                onClose={() => setShowPaymentDlg(false)}
                onCancel={handleCancelWithConfirmation}
                status={payStat}
                loading={payLoad}
                error={payErr}
                cancelling={cancelBusy}
                userId={userId}
                userType={+userType}           // ensure number (1 = client, 2 = accountant)
                refreshStatus={refreshPaymentStatus}
            />

            {/* PCN Modal */}
            <PCNModal
                open={showPCNModal}
                onClose={() => setShowPCNModal(false)}
                direction={direction}
                isDateRange={isDateRange}
                setIsDateRange={setIsDateRange}
                date={date}
                setDate={setDate}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                CustomMonthDatePicker={CustomMonthDatePicker}
                pcnIncludeStornoChecks={pcnIncludeStornoChecks}
                setPcnIncludeStornoChecks={setPcnIncludeStornoChecks}
                pcnChecksLoading={pcnChecksLoading}
                handlePCNChecks={handlePCNChecks}
                handlePCNDownload={handlePCNDownload}
                t={t}
                caseId={client?.caseId}
                token={token}
                viewDocumentDetails={(type) => {
                    // Navigate to the appropriate page based on type
                    if (type === 'Incomes') {
                        navigate(`/client-details/${client?.caseId}/incomes`);
                    }
                }}
            />

            {/* PCN Documents Check Modal */}
            <PCNChecksModal
                open={showPCNChecksModal}
                onClose={() => setShowPCNChecksModal(false)}
                direction={direction}
                t={t}
                pcnHighConfirmationDocs={pcnHighConfirmationDocs}
                pcnDocumentsNeedingAllocation={pcnDocumentsNeedingAllocation}
                pcnDocumentsWithoutReference={pcnDocumentsWithoutReference}
                pcnDocumentsOutOfRange={pcnDocumentsOutOfRange}
                pcnReportDetails={pcnReportDetails}
                onDocumentClick={handleDocumentRowClickInDownloadImportModals}
                setShowPCNModal={setShowPCNModal}
                handlePCNDownload={handlePCNDownload}
                startDate={isDateRange ? startDate : date}
                endDate={isDateRange ? endDate : date}
                caseId={client?.caseId}
                token={token}
                includeStornoChecks={pcnIncludeStornoChecks}
                sortCodeIdOptions={sortCodeIdOptions}
                accountCardOptions={AccountCardOptions.filter(opt => opt.cardId)}
                viewDocumentDetails={(type) => {
                    // Navigate to the appropriate page based on type
                    if (type === 'Incomes') {
                        navigate(`/client-details/${client?.caseId}/incomes`);
                    }
                }}
            />

            {/* Example of Enhanced CustomModal with Date Pickers and Radio Groups */}

        </>
    );
}

export default HamburgerMenu;
